
        export default {
          mounted() {
            this.handleEvent("challenge_validation_failed", () => {
              window.requestAnimationFrame(() => {
                const invalid = this.el.querySelector(
                  ".input-error, .select-error, .textarea-error, [data-challenge-error='true']"
                )

                if (invalid) {
                  invalid.focus({preventScroll: true})
                  invalid.scrollIntoView({behavior: "smooth", block: "center"})
                }
              })
            })
          }
        }
      